<template>
    <v-toolbar style="margin-top: 10px !important;" color="rgba(255, 255, 255, .5)" flat scroll-off-screen>
        <v-btn large dark color="primary" flat @click="$emit('btnNovoReajusteClicado')"
               v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'">
            <v-icon>add_circle_outline</v-icon>
            <span class="ml-2 font-weight-black text-capitalize"> Reajuste </span>
        </v-btn>
    </v-toolbar>
</template>

<script>
export default {
    name: 'ToolbarIndicesPreco'
}
</script>

<style scoped lang="stylus">

</style>